import { Box, Fade, Tooltip, Typography } from '@mui/material'
import CustomChip from '../../../../../shared/components/CustomChip'
import HighlightIcon from '../../../../../shared/components/icons/HighlightIcon'
import VisibilityIcon from '../../../../../shared/components/icons/VisibilityIcon'

interface NoveltiesTitleCellProps {
  params: any
  onHighlight: (id: number, isHighlight: boolean) => void
}

const NoveltiesTitleCell = ({ params, onHighlight }: NoveltiesTitleCellProps) => {
  const getStatusChip = (status: number) => {
    switch (status) {
      case 0:
        return <CustomChip size="small" color={'primary'} />
      case 1:
        return <CustomChip size="small" color={'secondary'} />
      case 2:
        return <CustomChip size="small" color={'grey'} />
      default:
        return <CustomChip size="small" color={'grey'} />
    }
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {getStatusChip(params.row.status)}
      <Tooltip placement="bottom-start" TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title={params.row.title}>
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            maxWidth: 300,
            fontWeight: 300,
            '@media (max-width: 600px)': {
              maxWidth: 150
            }
          }}
        >
          {params.row.title}
        </Typography>
      </Tooltip>
      <HighlightIcon id={params.row.id} isHighlight={!!params.row.highlight} handleClick={onHighlight} />
      <VisibilityIcon id={params.row.visibility} />
    </Box>
  )
}

export default NoveltiesTitleCell
